module.exports = __webpack_public_path__ + "img/struc-rect-column.f87e204b.png";